<template>
	<div id="tour">	
		<h1 class="intro">TOUR:</h1>
		<div style="margin-top: 2.5em;">		
			<ul class="tour-dates">
				<li v-for="item in items" v-bind:key="item.id"><strong>{{ item.date | formatDate }}</strong> - <a v-bind:href="item.url" target="_blank">{{ item.venueCity }} - {{ item.venueName }}</a></li>				
			</ul>	
		</div>	
	</div>
</template>

<script>
import axios from "axios";

export default {
  name: 'Tour',
  data() {
    return {
      items: []
    };
  },
  mounted: function() {
	  this.$parent.close_mobile();
  },
  created: function() {
	axios.get("https://rest.bandsintown.com/artists/the%20armed/events/?app_id=738b7f7e6d5a2f2d129d5d68a5f304bb").then((result) => {
		if(result.data != null){
			for(var i = 0; i < result.data.length; i++){
				this.items.push({
					id: result.data[i].id,
					date: result.data[i].datetime,
					venueCity: result.data[i].venue.city,
					venueName: result.data[i].venue.name,
					url: result.data[i].url
				});				
			}
		}  
    });
  }
}
</script>
